import SafenetCard from './SafenetCard';

export default SafenetCard;
